import type { MortgageRateBand } from "web_myplann/Inspiration/Types/MortgageRateBand";
import { formatRate } from "web_myplann/Shared/Utils/percentageFormatters";

export const formatRateBand = (band: MortgageRateBand) =>
	band.best === band.worst
		? formatRate(band.best)
		: `${formatRate(band.best)}–${formatRate(band.worst)}`;
